import React from 'react'

const Info = () => (
  <svg viewBox="0 0 21 21" width="21px" height="21px">
    <g transform="translate(0.5 0.5)">
      <g enableBackground="new    ">
        <path
          fill="#121212"
          d="M9.3,6.8C9.1,6.6,9,6.3,9,6.1c0-0.3,0.1-0.5,0.3-0.7C9.5,5.1,9.7,5,10,5c0.3,0,0.5,0.1,0.7,0.3
			C10.9,5.5,11,5.8,11,6.1c0,0.3-0.1,0.5-0.3,0.7S10.3,7.1,10,7.1C9.7,7.1,9.5,7,9.3,6.8z M10.7,16H9.3V8.8h1.4V16z"
        />
      </g>
      <circle fill="none" stroke="#121212" strokeMiterlimit="10" cx="10" cy="10" r="10" />
    </g>
  </svg>
)

export default Info
